import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { BasicLogo } from 'page/catalog/BasicLogo/BasicLogo'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './BasicHeader.module.scss'

export const BasicHeader = observer(() => {
  const demo = useDemo()
  const { logo } = demo.product

  if (!logo) return null

  return <Space className={css.header} center>
    <BasicLogo />
  </Space>
})
